import React, { useState, useEffect } from 'react';
import { 
  collection, addDoc, query, orderBy, onSnapshot, deleteDoc, doc, serverTimestamp, getDocs, writeBatch, getDoc 
} from "firebase/firestore";
import { db } from './firebase';
import { Star, Trash2, User, Send, Loader2, MessageSquare, Code, Check, X, Copy, ExternalLink } from 'lucide-react'; // Aggiunte icone

// --- IMPORTANTE: INSERISCI QUI IL LINK ALLE RECENSIONI GOOGLE DI ITAD ---
// Puoi trovarlo nel tuo profilo Google Business -> "Chiedi recensioni" -> Copia link
// Esempio: "https://g.page/r/CODICE_ITAD/review"
const GOOGLE_REVIEW_LINK = "https://g.page/r/CcrqxbkpGOvGEBM/review"; 
// Funzione per estrarre solo il nome pulito (taglia a spazio o @)
const getCleanFirstName = (displayName) => {
  if (!displayName) return 'User';
  // 1. Toglie spazi vuoti
  // 2. Prende la prima parola (prima dello spazio)
  // 3. Prende la parte prima della @ (se è una mail)
  return displayName.trim().split(/\s+/)[0].split('@')[0];
};
const ReviewsPage = ({ user, userRole }) => {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0); 
  const [hoverRating, setHoverRating] = useState(0); 
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);

  // Nuovo stato per il Modale Google
  const [showGoogleModal, setShowGoogleModal] = useState(false);

  // Carica le recensioni in tempo reale
  useEffect(() => {
  setLoading(true);
  const q = query(collection(db, 'reviews'), orderBy('createdAt', 'desc'));
  
  const unsubscribe = onSnapshot(q, async (snapshot) => {
    const reviewData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // --- LOGICA DI FIX PER I NOMI VECCHI ---
    const fixedReviews = await Promise.all(reviewData.map(async (rev) => {
      // Se il nome sembra un'email o è mancante, cerchiamo nel database utenti
      if (!rev.displayName || rev.displayName.includes('@')) {
        try {
          const userDoc = await getDoc(doc(db, 'users', rev.uid));
          if (userDoc.exists() && userDoc.data().firstName) {
            return { ...rev, displayName: userDoc.data().firstName };
          }
        } catch (e) {
          console.error("Errore recupero nome utente", e);
        }
      }
      // Se non è una mail, prendiamo solo la prima parola (FirstName)
      return { ...rev, displayName: rev.displayName.split(' ')[0] };
    }));

    setReviews(fixedReviews);
    setLoading(false);
  });
  
  return () => unsubscribe();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert("Please select a star rating!");
      return;
    }
    if (!comment.trim()) {
      alert("Please write a comment.");
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'reviews'), {
  uid: user.uid,
  userEmail: user.email,
  // Salviamo direttamente ed esclusivamente il firstName
  displayName: user.firstName || user.email.split('@')[0], 
  rating: rating,
  comment: comment.trim(),
  createdAt: serverTimestamp(),
  role: userRole
});
      
      // INVECE DI RESETTARE SUBITO, APRIAMO IL MODALE GOOGLE
      setShowGoogleModal(true);
      // Non resettiamo ancora comment e rating, servono per la copia!

    } catch (error) {
      console.error("Error adding review:", error);
      alert("Error submitting review");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Funzione chiamata quando l'utente vuole copiare e andare su Google
  const handleGoogleRedirect = () => {
    // 1. Copia il commento nella clipboard
    navigator.clipboard.writeText(comment).then(() => {
      // 2. Apre Google in una nuova scheda
      window.open(GOOGLE_REVIEW_LINK, '_blank');
      // 3. Chiude e resetta
      handleCloseModal();
    }).catch(err => {
      console.error('Failed to copy: ', err);
      // Fallback se la copia fallisce: apre comunque il link
      window.open(GOOGLE_REVIEW_LINK, '_blank');
      handleCloseModal();
    });
  };

  // Funzione per chiudere il modale e resettare il form
  const handleCloseModal = () => {
    setShowGoogleModal(false);
    setRating(0);
    setComment('');
    // Opzionale: alert di ringraziamento finale se l'utente clicca "No thanks"
  };

  const handleDelete = async (reviewId) => {
    if (window.confirm("Are you sure you want to delete this review?")) {
      try {
        await deleteDoc(doc(db, 'reviews', reviewId));
      } catch (error) {
        console.error("Error deleting review:", error);
      }
    }
  };

  const handleCopyEmbed = (review) => {
  const stars = "★".repeat(review.rating) + "☆".repeat(5 - review.rating);
  
  // Usiamo la funzione di pulizia
  const firstNameOnly = getCleanFirstName(review.displayName);

  const embedCode = `
<div style="font-family: sans-serif; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; background: #ffffff; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); max-width: 400px; margin: 10px 0;">
  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px;">
    <div style="background: #f3f4f6; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; color: #666; text-transform: uppercase;">
      ${firstNameOnly.charAt(0)}
    </div>
    <div>
      <div style="font-weight: bold; color: #111; text-transform: capitalize;">${firstNameOnly}</div>
      <div style="font-size: 0.85rem; color: #6b7280; text-transform: capitalize;">${review.role}</div>
    </div>
  </div>
  <div style="color: #fbbf24; font-size: 1.2rem; letter-spacing: 2px; margin-bottom: 10px;">
    ${stars}
  </div>
  <p style="color: #374151; line-height: 1.5; font-style: italic; margin: 0;">
    "${review.comment}"
  </p>
</div>`;

  navigator.clipboard.writeText(embedCode).then(() => {
    alert("Codice HTML copiato!");
  });
};

  const averageRating = reviews.length > 0 
    ? (reviews.reduce((acc, curr) => acc + curr.rating, 0) / reviews.length).toFixed(1) 
    : 0;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', paddingBottom: '5rem' }}>
      
      {/* HEADER */}
      <div style={{ 
        background: 'white', padding: '2rem', borderRadius: '16px', 
        marginBottom: '1.5rem', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
      }}>
        <h2 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <MessageSquare size={28} /> Reviews & Feedback
        </h2>
        <div style={{ fontSize: '3rem', fontWeight: 'bold', margin: '10px 0', color: '#fbbf24' }}>
          {averageRating} <span style={{ fontSize: '1.5rem', color: '#ccc' }}>/ 5</span>
        </div>
        <p style={{ color: '#666' }}>Based on {reviews.length} reviews</p>
      </div>

      {/* FORM */}
      <div style={{ 
        background: 'white', padding: '1.5rem', borderRadius: '16px', 
        marginBottom: '2rem', border: '1px solid #eef2ff'
      }}>
        <h3 style={{ marginBottom: '1rem' }}>Leave a Review</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', gap: '5px', marginBottom: '1rem', cursor: 'pointer' }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                size={32}
                fill={(hoverRating || rating) >= star ? "#fbbf24" : "none"}
                color={(hoverRating || rating) >= star ? "#fbbf24" : "#ccc"}
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                onClick={() => setRating(star)}
                style={{ transition: 'all 0.2s' }}
              />
            ))}
          </div>

          <textarea
            className="input-text"
            rows="4"
            placeholder="Share your experience with the ITAD Study Trip..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{ resize: 'vertical' }}
          />

          <button 
            className="btn-primary" 
            type="submit" 
            disabled={isSubmitting}
            style={{ justifyContent: 'center' }}
          >
            {isSubmitting ? <Loader2 className="animate-spin" /> : <> <Send size={18} /> Publish Review </>}
          </button>
        </form>
      </div>

      {/* LISTA RECENSIONI */}
      <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}><Loader2 className="animate-spin" /></div>
        ) : reviews.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#999' }}>No reviews yet. Be the first!</p>
        ) : (
          reviews.map((review) => (
            <div key={review.id} className="card" style={{ padding: '1.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ 
                    width: '40px', height: '40px', borderRadius: '50%', 
                    background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center' 
                  }}>
                    <User size={20} color="#666" />
                  </div>
                  <div>
  <h4 style={{ fontSize: '0.95rem', margin: 0 }}>
  {review.displayName || 'User'}
</h4>
  <span style={{ fontSize: '0.75rem', color: '#888' }}>
    {review.role === 'admin' ? 'Admin' : review.role === 'docente' ? 'Teacher' : 'Student'}
  </span>
</div>
                </div>
                
                <div style={{ display: 'flex', gap: '2px' }}>
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} size={16} fill={review.rating >= s ? "#fbbf24" : "#eee"} color={review.rating >= s ? "#fbbf24" : "#ddd"} />
                  ))}
                </div>
              </div>

              <p style={{ margin: '1rem 0', lineHeight: '1.5', color: '#333' }}>
                {review.comment}
              </p>

              <div style={{ 
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', 
                marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #f0f0f0' 
              }}>
                <span style={{ fontSize: '0.75rem', color: '#999' }}>
                   {review.createdAt?.toDate().toLocaleDateString()}
                </span>
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  {userRole === 'admin' && (
                    <button
                      onClick={() => handleCopyEmbed(review)}
                      style={{ 
                        background: '#e0f2fe', border: 'none', color: '#0284c7', 
                        cursor: 'pointer', display: 'flex', alignItems: 'center', 
                        gap: '5px', fontSize: '0.8rem', padding: '5px 10px', borderRadius: '6px',
                        fontWeight: 600
                      }}
                      title="Copy HTML for Website"
                    >
                      <Code size={14} /> Embed Code
                    </button>
                  )}

                  {(userRole === 'admin' || user.uid === review.uid) && (
                    <button 
                      onClick={() => handleDelete(review.id)}
                      style={{ 
                        background: 'none', border: 'none', color: '#ef4444', 
                        cursor: 'pointer', display: 'flex', alignItems: 'center', 
                        gap: '5px', fontSize: '0.8rem' 
                      }}
                    >
                      <Trash2 size={14} /> Delete
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* --- MODALE GOOGLE --- */}
      {showGoogleModal && (
        <div className="modal-overlay" style={{zIndex: 2000}}>
          <div className="modal-content" style={{maxWidth: '450px', textAlign: 'center', padding: '2.5rem'}}>
            <div style={{
              width: '60px', height: '60px', background: '#e3f2fd', 
              borderRadius: '50%', display: 'flex', alignItems: 'center', 
              justifyContent: 'center', margin: '0 auto 1.5rem'
            }}>
              <Star size={30} fill="#f57c00" color="#f57c00" />
            </div>
            
            <h3 style={{fontSize: '1.5rem', marginBottom: '0.5rem'}}>Review Published!</h3>
            <p style={{color: '#666', marginBottom: '2rem', lineHeight: '1.5'}}>
              Thank you for your feedback on the App.<br/>
              <strong>Would you mind posting this on Google too?</strong><br/>
              It helps us a lot!
            </p>

            <button 
              className="btn-primary" 
              onClick={handleGoogleRedirect}
              style={{
                width: '100%', justifyContent: 'center', marginBottom: '1rem',
                background: '#4285F4', // Colore Google Blue
                border: 'none'
              }}
            >
              <Copy size={18} /> Copy Text & Open Google
            </button>

            <button 
              onClick={handleCloseModal}
              style={{
                background: 'none', border: 'none', color: '#999', 
                cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'underline'
              }}
            >
              No thanks, maybe later
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default ReviewsPage;